// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f330ceae","134":"b8e5c846","320":"34e59611","430":"9ad90395","550":"6978a2aa","650":"dc985fa4"}[chunkId] + ".chunk.js";
};